import React, { useEffect, useState } from "react";

import { useAppDispatch } from "../../../../../src/app/hooks";
import StageWorkflowAssignOfficerModal from "../../../stageWorkflow/components/StageWorkflowAssignOfficerModal";
import { AddStageRequest, CaseStageAction, CaseStageEnum } from "src/api/caseStages";
import { AcceptButton } from "../../../../../src/components/ui/button/v2/AcceptButton";
import { useParams } from "react-router-dom";
import { useAppSelector } from "../../../../../src/app/store";
import { getIOAppointingAuthorities } from "../../../../../src/features/users/logic/slice";
import { fetchIOAppointingAuthorities } from "../../../../../src/features/users/logic/thunk";
import { updateCaseStage } from "../../logic/thunks";
import { showErrorToast, showSuccessToast } from "../../../../../src/lib/toast";
import { sortOptions } from "../../../../lib/utils";

export const AssignIOAppAuth: React.FC<{
  next_stage: CaseStageEnum
}> = ({next_stage})=> {
  const dispatch = useAppDispatch();
  const { id: caseId } = useParams<{ id: string }>();

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isFetchingAuthorities, setIsFetchingAuthorities] = useState(false);

  const ioAuthorities = useAppSelector(getIOAppointingAuthorities);

  const officerOptions =sortOptions(
    ioAuthorities?.map((user) => ({ 
      name: user.user_name || "", 
      value: user.user_id || user.email_id || "" 
    })) ?? []
  );

  useEffect(() => {
    if (ioAuthorities.length === 0) {
      setIsFetchingAuthorities(true);
      dispatch(fetchIOAppointingAuthorities()).finally(() => {
        setIsFetchingAuthorities(false);
      });;
    }
  }, [ioAuthorities.length, dispatch]);

  const handleOpen = (): void => {
    setIsModalOpen(true);
  };

  const handleClose = (): void => {
    setIsModalOpen(false);
  };

  const handleConfirm = async (selectedOfficer: string): Promise<void> => {
    if (!caseId || !selectedOfficer) return;

    try {
      setIsLoading(true);

      const request: AddStageRequest = {
        stage: next_stage,
        source_action: CaseStageAction.ASSIGN_IO_APP_AUTH,
        stage_data: {
          io_app_authority: selectedOfficer,
        },
      };

      await dispatch(
        updateCaseStage({
          caseId,
          request,
        })
      ).unwrap();

      showSuccessToast("IO Appointing Authority assigned successfully");
      setIsModalOpen(false);
    } catch (error) {
      console.log(error);
      showErrorToast("Failed to assign IO Appointing Authority");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <AcceptButton label="Assign" onClick={handleOpen} />

      <StageWorkflowAssignOfficerModal
        isOpen={isModalOpen}
        options={officerOptions}
        onClose={handleClose}
        onConfirm={handleConfirm}
        title="Nominate IO Appointing Authority"
        loading={isLoading}
        isFetchingOptions={isFetchingAuthorities} 
      />
    </>
  );
};
